const GovernaceAndAdministrationdata = [{
    id : "1",
    schemeName: "Member of Parliament Local Area Development Scheme",
    discription:"The Local Area Development Scheme, also known as MPLADS is a government scheme launched with an initiative to enable the parliament members to recommend developmental work in their constituencies based on locally felt needs such as drinking water, education, public health, sanitation, roads, etc.",
    launchDate: "23 December 1993",
    AnualFund: "12345"

},
{id : "2",
schemeName: "Kabir Puraskar Scheme for acts of courage during communal riots",
discription:"This scheme is instituted to promote communal, caste and ethnic harmony by recognizing acts of physical/moral courage and humanity exhibited by member(s) of one a community, caste or ethnic group in saving the lives and properties of the member(s) of another community, caste or ethnic group. The Award may be given by the Central Government and presented to the recipients by the Prime Minister. You can find information on award prize money, purpose of this award, eligibility criterion, method of selection, timing of announcement of award, etc.",
launchDate: " year 1990",
AnualFund: "12345"},


{id : "3",
schemeName: "Swatantrata Sainik Samman Pension Scheme",
discription:"It was introduced by the Government of India. The Scheme commenced from 15th August, 1972 and provided for the grant of pension to living freedom fighters and their families; if they are no more alive, and to the families or martyrs.",
launchDate: "15 August 1972",
AnualFund: "12345"},

{
id : "4",
    schemeName: "Scheme of house building advance to Central Government employees",
    discription:"The Centre is offering House Building Advance (HBA) to its 52 lakh Central government employees. The scheme, which rolled out in June 2020, aims to provide loans at cheaper rates to government employees who are planning to construct their houses.",
    launchDate: "1 October 2020",
    AnualFund: "12345"
},
{ id : "5",
schemeName: "Mission Karmayogi Scheme",
discription:"Mission Karmayogi is the National Programme for Civil Services Capacity Building (NPCSCB). It is a reform in Indian Bureaucracy. Union Cabinet launched it on 2nd September 2020 The mission intends to lay down the foundations for the Indian civil servants' capacity building and aims to enhance governance.",
launchDate: "2 September 2020", 
 AnualFund: "12345"},
]

export default GovernaceAndAdministrationdata;